// @flow
import * as React from "react";
import idx from "idx";
import { connect } from "react-redux";
import { withRouter, type Location } from "react-router-dom";
import querystring from "querystring";

import SimpleSpinner from "./Spinner";
import withData from "../withData";
import { inferLocale } from "../common/Gettext";

import type { MapStateToProps } from "react-redux";
import type { State as ReduxState } from "../../redux/reducer";

const getApi = () => {
  return window.HELPDESK_API_URL
};

const API = getApi();

type Spinner = "brand" | "simple" | "none";

type CurrSlugProps = {
  slug: string,
  type: string,
  spinner?: Spinner,
};

export type FetchProps = {
  dispatch: Function,
  getData: (page: string, headers?: Object) => Promise<*>,
    requestCurrentSlug: (props: { slug: string, type: string }) => void,
};

type Props = {
  // xLocale: string,
  locale: string,
  profile: null | Object,
  currency: string,
};

export type QueriesObj = {
  lang: string,
  currency: string,
  tags?: number,
};

export function inferHelpdeskLocale(locale: string) {
  // helpdesk locales
  const availableXLocales = new Set([
    "en",
    "th",
    "vn",
    "ph",
    "hi",
    "ar",
    "id",
    "es",
    "cn",
    "tr",
    "ru",
  ]);

  const xLocaleObj = {
    en: "en_US",
    th: "th_TH",
    vn: "vi_VN",
    ph: "fil_PH",
    hi: "hi_HI",
    ar: "ar_AR",
    ru: "ru_RU",
    id: "id_ID",
    es: "es_AR",
    cn: "cn",
    tr: "tr_TR",
  };

  return xLocaleObj[availableXLocales.has(locale) ? locale : "en"];
}

const mapStateToProps = (state: ReduxState) => {
  const { helpdesk, apiConfigs, serverData } = state;

  return {
    ...helpdesk,
    currency: serverData
        ? serverData.currency
        : (apiConfigs && apiConfigs.defaultCurrency) || "USD",
    locale: inferLocale(state),
  };
};

// проверяем, едут ли к нам данные
const inFlight = new Set();

function withFetch(
    WrappedComponent: React.ComponentType<*>,
    spinner?: Spinner = null
) {
  class Fetch extends React.Component<Props & { dispatch: Function }, {}> {
    commonData = (page: string, object?: Object = { headers: {} }) => {
    const { headers, ...etc } = object;
  const { locale } = this.props;

  const fetchObject = {
    headers: {
      "X-LOCALE": inferHelpdeskLocale(locale),
      "X-CURRENCY": this.props.currency.toUpperCase(),
      accept: "application/json",
      ...headers,
    },
    ...etc,
  };

  return fetch(`${API}${page}`, fetchObject);
};

  getData = (page: string, headers?: Object) => {
    return this.commonData(page, headers)
        .then((response) => {
          const { status } = response;
          switch (status) {
            case 200:
              return response.json();
            default:
              return { status };
          }
        })
        .catch(() => {
          throw new TypeError("Expected response with status 200");
        });
  };

  requestCurrentSlug = ({ slug, type }: { slug: string, type: string }) => {
    const { locale, currency } = this.props;
    // если данные не в процессе приезда
    // и если locale установилась
    if (!inFlight.has(slug) && locale !== null) {
      inFlight.add(slug);

      const queries: QueriesObj = {
        lang: inferHelpdeskLocale(locale),
        currency,
      };

      if (this.props.profile !== null) {
        queries.tags = 4;
      }

      let url = `page/${slug}`;
      switch (type) {
        case "news":
          url = slug;
          break;
        default:
          break;
      }

      try {
        this.getData(`/api/${url}?${querystring.stringify(queries)}`).then(
            (payload) => {
              switch (type) {
                case "news":
                  this.props.dispatch({
                    type: "RECEIVE_HELPDESK_NEWS",
                    payload,
                  });
                  break;
                default:
                  this.props.dispatch({
                    type: "RECEIVE_HELPDESK_PAGE",
                    payload,
                  });
                  break;
              }
              inFlight.delete(slug);
            }
        );
      } catch (error) {
        console.error(error);
      }
    }
  };

  render() {
    return (
        <WrappedComponent
    getData={this.getData}
    requestCurrentSlug={this.requestCurrentSlug}
    {...this.props}
    />
  );
  }
}

  return withData({
    required: ["serverData"],
    optional: ["profile"],
    spinner: spinner,
  })(connect((mapStateToProps: MapStateToProps<*, *, *>))(Fetch));
}

type SlugFetchProps = FetchProps &
    Props & {
      location: Location,
    };

export function withSlugFetch(
    WrappedComponent: React.ComponentType<*>,
    { slug, type, spinner = null }: CurrSlugProps
) {
  class SlugFetch extends React.Component<SlugFetchProps, {}> {
    componentDidMount() {
      if (!this.props[slug]) {
        this.props.requestCurrentSlug({ slug, type });
      }
    }

    render() {
      if (this.props.locale && this.props[slug]) {
        return <WrappedComponent {...this.props} />;
      }

      if (spinner === "none") {
        return null;
      }

      return <SimpleSpinner height="300px" />;
    }
  }

  return withRouter(
      withFetch((props: SlugFetchProps) => {
        const id = idx(props, (props) => props.profile.id) || 0;

        return (
            <SlugFetch
        {...props}
        key={
          slug + id + props.locale + props.currency + props.location.pathname
        }
        />
      );
      })
  );
}

export default withFetch;



// WEBPACK FOOTER //
// ./src/components/Helpdesk/withFetch.js